import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import AddIcon from '@material-ui/icons/Add';
import classnames from 'classnames';
import Cookies from 'universal-cookie';
import { isUndefined, isEmpty } from 'lodash';

// Scheduling content feature
import ScheduleModal from '../Modals/ScheduleModal2';

import RemoveModal from '../Modals/RemoveModal';
import PreviewModal from '../Modals/PreviewModal';
import DeleteModal from '../Modals/DeleteModal';
import EditTagsModal from '../Modals/EditTagsModal';
import { uploadContentService } from '../../../services';

import './index.scss';
import { orange } from '@material-ui/core/colors';


const BootstrapInput = withStyles((theme) => ({
  root: {
    ' + ': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: orange[800],
    border: '1px solid #ff8000',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: orange[800],
      backgroundColor: orange[800],
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  item: {
    width: 200,

  },
}));


export default function CustomizedSelects({ id }) {
  const classes = useStyles();
  const cookies = new Cookies();
  const history = useHistory();

  let hasTaggedPlaylist = cookies.get('hasTaggedPlaylist');

  const [option, setOption] = useState('');

  const handleChange = (event) => {
    setOption(event.target.value);
  };

  const [isPreviewModalShow, setIsPreviewModalShow] = useState(false);
  const [isScheduleModalShow, setIsScheduleModalShow] = useState(false);
  const [isRemoveModalShow, setIsRemoveModalShow] = useState(false);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [isEditTagsModalShow, setIsEditTagsModalShow] = useState(false);

  // const [uploadContents, setUploadContents] = useState([]);
  // const [taggedPlaylist, setTaggedPlaylist] = useState([]);

  const { user } = useSelector(state => state.userAuthentication);

  const getUploadedContents = useCallback(async () => {
    if (!isUndefined(user)) {
      return await uploadContentService.uploadContent(user);
    }
  }, [user]);

  const fetchTaggedPlaylists = useCallback(async () => {
    if (!isUndefined(user)) {
      return await uploadContentService.taggedPlaylists(user);
    }
  }, [user]);

  const processCheckingOfTaggedPlaylist = (uploadContents, taggedPlaylist) => {
    let taggedPlaylistArr = [];
    let uploadContentArr = [];

    if (!isUndefined(uploadContents) && !isUndefined(taggedPlaylist)) {
      [...taggedPlaylist].map(item => {
        taggedPlaylistArr.push(item.id);
      });

      [...uploadContents].map(item => {
        if ("taggedPlaylists" in item) {
          const taggedPlaylists = item.taggedPlaylists;
          [...taggedPlaylists].map(i => {
            uploadContentArr.push(i.id);
          });
        }
      });
    }

    [...uploadContentArr].map(item => {
      if (taggedPlaylistArr.includes(item)) {
        cookies.set('contentHasTaggedPlaylists', true);
      } else {
        cookies.set('contentHasTaggedPlaylists', false);
      }
    });

    history.push("/tagged-content");
  }

  const handleClick = (event) => {
    const currentTarget = event.target.dataset.value;

    if (currentTarget === "schedule-modal") {
      setIsScheduleModalShow(true);
    } else if (currentTarget === "remove-modal") {
      setIsRemoveModalShow(true);
    } else if (currentTarget === "preview-modal") {
      setIsPreviewModalShow(true);
    } else if (currentTarget === "delete-modal") {
      setIsDeleteModalShow(true);
    } else if (currentTarget === "edit-tags-modal") {
      setIsEditTagsModalShow(true);
    } else if (currentTarget === "tags-content-redirection") {
      let uploadContents = [];
      let taggedPlaylist = [];

      getUploadedContents()
        .then(res => {
          uploadContents = res?.items;
          fetchTaggedPlaylists()
            .then(res => {
              taggedPlaylist = res?.items;
              processCheckingOfTaggedPlaylist(uploadContents, taggedPlaylist);
            })
        })
    }
  };

  const handleClose = () => {
    setIsPreviewModalShow(false);
  };

  return (
    <>
      {id ? (
        <div className="dropdown-selection-container">
          <FormControl className={classnames(
            classes.margin,
            "dropdown-selection")}>
            <Select
              IconComponent={AddIcon}
              classname="demo-customized-select-label"
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              value={option}
              // onChange={handleChange}
              input={<BootstrapInput />}>
              <MenuItem className={classes.item} value="schedule-modal" onClick={handleClick}>Schedule </MenuItem>
              
              {hasTaggedPlaylist === 'true' ? (
                <MenuItem className={classes.item} value="tags-content-redirection" onClick={handleClick}>Tags </MenuItem>
              ) : ''}

              <MenuItem className={classes.item} value="edit-tags-modal" onClick={handleClick}>Edit Tags </MenuItem>
              <MenuItem className={classes.item} value="remove-modal" onClick={handleClick}>Remove Schedule</MenuItem>
              <MenuItem className={classes.item} value="preview-modal" onClick={handleClick}>Preview</MenuItem>
              <MenuItem className={classes.item} value="delete-modal" onClick={handleClick}>Delete</MenuItem>
            </Select>
            {isScheduleModalShow ? (<ScheduleModal modalShow={isScheduleModalShow} modalState={setIsScheduleModalShow} id={id} />) : ''}
            {isRemoveModalShow ? (<RemoveModal modalShow={isRemoveModalShow} modalState={setIsRemoveModalShow} id={id} />) : ''}
            {isDeleteModalShow ? (<DeleteModal modalShow={isDeleteModalShow} modalState={setIsDeleteModalShow} id={id} />) : ''}
            {isPreviewModalShow ? (<PreviewModal modalShow={isPreviewModalShow} modalState={setIsPreviewModalShow} id={id} />) : ''}
            {isEditTagsModalShow ? (<EditTagsModal modalShow={isEditTagsModalShow} modalState={setIsEditTagsModalShow} id={id} />) : ''}
          </FormControl>
        </div>
      ) : ''}
    </>
  );
}
